import '../css/main.scss'
import * as React from 'react'
import { IO, pipe, E, TE, DOM, t, T, RD } from '@packages/prelude'
import { ConfiguratorApp } from './components/ConfiguratorApp'
import { react } from './commons'
import { configuration } from './api'

// Initialize React app with data fetching
document.addEventListener(
  'DOMContentLoaded',
  pipe(
    TE.of({ document }),
    TE.bind('configurator', ({ document }) =>
      pipe(
        document,
        DOM.querySelector('#hot-tub-configurator'),
        IO.map(E.fromOption(() => new Error('Configurator not found on page'))),
        TE.fromIOEither
      )
    ),
    TE.bind('productId', ({ configurator }) =>
      pipe(
        configurator.getAttribute('data-product-id'),
        t.NumberFromString.decode,
        E.mapLeft(() => new Error('No product ID specified')),
        TE.fromEither
      )
    ),
    TE.bind('configId', ({ configurator }) =>
      pipe(
        configurator.getAttribute('data-configuration-id'),
        t.NonEmptyString.decode,
        E.mapLeft(() => new Error('No configuration ID specified')),
        TE.fromEither
      )
    ),
    TE.bind('basePrice', ({ configurator }) =>
      pipe(
        configurator.getAttribute('data-base-price'),
        t.NumberFromString.decode,
        E.alt(() => E.right(0)),
        E.mapLeft(() => new Error('No base price specified')),
        TE.fromEither
      )
    ),
    TE.bind('categoryName', ({ configurator }) =>
      pipe(
        configurator.getAttribute('data-category-name'),
        t.NonEmptyString.decode,
        E.mapLeft(() => new Error('No category name specified')),
        TE.fromEither
      )
    ),
    TE.bind('deliveryNotice', ({ configurator }) =>
      pipe(
        configurator.getAttribute('data-delivery-notice'),
        t.NonEmptyString.decode,
        E.mapLeft(() => new Error('No delivery notice specified')),
        TE.fromEither
      )
    ),
    TE.bind('configuration', ({ configId }) => configuration.fetchConfiguraton(configId)),
    TE.mapLeft(error => {
      console.error('Error in configurator:', error)
      return T.fromIO(() => console.error(error))
    }),
    TE.map(({ basePrice, categoryName, configurator, configuration, deliveryNotice, productId }) =>
      pipe(
        configurator,
        react.mountTo(() => (
          <ConfiguratorApp
            configuraton={RD.success(configuration)}
            basePrice={basePrice}
            productId={productId}
            categoryName={categoryName}
            deliveryNotice={deliveryNotice}
          />
        ))
      )
    )
  )
)
